import { useFormik } from "formik";
import moment from "moment";
import { useState } from "react";
import { useQuery, useQueryClient } from "react-query";
import CustomTable from "../../../Shared/CustomTable";
import CustomToPagination from "../../../Shared/Pagination";
import { apiConnectorPost } from "../../../utils/APIConnector";
import { endpoint } from "../../../utils/APIRoutes";
import { formatedDate, getFloatingValue } from "../../../utils/utilityFun";
import CustomTableSearch from "../../Shared/CustomTableSearch";

const TicketAndSupport = () => {
    const [page, setPage] = useState(1);
    const client = useQueryClient();
    const initialValues = {
        search: "",
        count: 10,
        start_date: "",
        end_date: "",
    };

    const fk = useFormik({
        initialValues: initialValues,
        enableReinitialize: true,
    });
    const { data, isLoading } = useQuery(
        [
            "get_all_tickets",
            fk.values.search,
            fk.values.start_date,
            fk.values.end_date,
            page,
        ],
        () =>
            apiConnectorPost(endpoint?.get_user_message, {
                search: fk.values.search,
                created_at: fk.values.start_date,
                updated_at: fk.values.end_date,
                page: page,
                count: fk.values.count,
                order: "DESC"
            }),
        {
            keepPreviousData: true,
            refetchOnMount: false,
            refetchOnReconnect: false,
            refetchOnWindowFocus: false,
            onError: (err) => console.error("Error fetching tickets data:", err),
        }
    );

    const allData = data?.data?.result || [];

    const tablehead = [
        <span>S.No.</span>,
        <span>Name</span>,
        <span>Email</span>,
        <span>Message</span>,
        <span>Msg Date</span>,
        <span>Reply</span>,
        <span>Rep Date</span>,
        <span>Action</span>,
    ];
    const tablerow = allData?.data?.map((row, index) => {
        return [
            <span> {(page - 1) * (fk.values.count || 10) + index + 1}</span>,
            <span> {row.lgn_name}</span>,
            <span>{row.lgn_email || "N/A"}</span>,
            <span> {row.tr54_user_msg || "N/A"}</span>,
            <span>{formatedDate(moment, row.tr54_msg_date)}</span>,
            <span>{row.tr54_reply || "N/A"}</span>,
            <span>{formatedDate(moment, row.tr54_reply_date)}</span>,
            <span>
                <button
                    style={{
                        background: "none", border: "none",
                        cursor: "pointer",
                        padding: "4px 8px",
                        color: "#6ae6b5",
                        borderRadius: "4px",
                        border: "1px solid #6ae6b5",
                        transition: "background 0.3s, color 0.3s",
                    }}
                    onClick={() => {
                        // Implement your reply logic here, e.g., open a modal to enter the reply
                        const replyMessage = prompt("Enter your reply:");
                        if (replyMessage) {
                            // Call the API to send the reply
                            apiConnectorPost(endpoint.admin_reply, {
                                message: replyMessage,
                                msg_id: row.tr54_id,
                            })
                                .then((response) => {
                                    alert("Reply sent successfully!");
                                    client.invalidateQueries(["get_all_tickets"]);
                                })
                                .catch((error) => {
                                    console.error("Error sending reply:", error);
                                    alert("Failed to send reply. Please try again.");
                                });
                        }
                    }}
                >
                    Reply
                </button>
            </span>,
        ];
    });
    return (
        <div className="p-2">


            <CustomTableSearch
                fk={fk}
                onClearFn={() => {
                    setPage(1);
                }}
                onSubmitFn={() => {
                    setPage(1);
                    client.invalidateQueries(["get_level_admin"]);
                }} />

            {/* Table Section */}
            <div
                className="
        rounded-lg py-3
        text-white
        bg-black
        border border-gray-700
        shadow-md shadow-white/20
      "
            >
                <CustomTable
                    tablehead={tablehead}
                    tablerow={tablerow}
                    isLoading={isLoading}
                />

                {/* Total Income */}
                {/* <div className="flex justify-end py-3 text-sm font-semibold text-green-400">
          Total Income : $ {allData?.totalAmount || 0}
        </div> */}

                {/* Pagination */}
                <CustomToPagination page={page} setPage={setPage} data={allData} />
            </div>
        </div>
    );
};

export default TicketAndSupport;
